/* eslint-disable */
import React, { useEffect, useMemo, useReducer, useState } from "react";
import Dialog from "components/Dialog/Dialog";
import api from "api";
import { dialogInitState, dialogReducer } from "reducers/dialog";
import { handleLoading, useLoading } from "context/LoadingContext";
import Table from "components/Table";
import EditPeople from "./EditPeople";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function People() {
  const [, loadingDispatch] = useLoading();
  const [dataTable, setDataTable] = useState([]);
  const [userData, setUserData] = useState(null);
  const [editPeopleDialogState, editPeopleDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleAddPeople = (data) => {
    if (data) setUserData(data);
    else setUserData(null);
    editPeopleDispatchDialog({ type: "TOGGLE" });
  };
  const headers = useMemo(
    () => [
      {
        accessorKey: "userId",
        header: "#",
        enableColumnFilter: false,
        filterInputInfo: {
          label: "رقم المستخدم",
          type: "",
        },
      },
      {
        accessorKey: "fullName",
        header: "اسم المواطن",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "اسم المواطن",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "userNationalId",
        header: "الرقم الوطني",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "الرقم الوطني",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "phoneNumber",
        header: "رقم الهاتف",
        filterInputInfo: {
          label: "رقم الهاتف",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "actions",
        header: "",
        cellClass: "table__actions",
        // eslint-disable-next-line react/no-unstable-nested-components
        cell: (param) => (
          <div className="table__actions__container">
            <button
              type="button"
              className="employee-requests__card__action badge badge--blue"
              onClick={toggleAddPeople.bind(this, param.cell.row.original)}
            >
              <i className="fa-solid fa-pen" />
            </button>
          </div>
        ),
      },
    ],
    [dataTable]
  );
  const getUsers = async () => {
    handleLoading(loadingDispatch, true);
    try {
      const usersRes = await api.post("/users/admin/citizens");
      const usersListFromRes = usersRes.data.data;
      setDataTable(usersListFromRes);
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };
  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      <div className="users employees">
        <div className="users__header">
          <h2 className="content__title title mt-3">المواطنين</h2>
        </div>
        <Table data={dataTable} columns={headers} />
      </div>
      <Dialog
        state={editPeopleDialogState}
        dispatch={editPeopleDispatchDialog}
        footer={false}
        title="تعديل المستخدم"
        closeButton
        centered
      >
        <EditPeople
          toggleDialog={toggleAddPeople}
          getUsers={getUsers}
          userData={userData}
        />
      </Dialog>
    </>
  );
}

export default People;
